<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.tracksWorkOrder'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('text.serialNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.orderInnerSerialNo"
            :placeholder="$t('order.innerSerialNo')"
          />
        </el-form-item>
        <customer-search
          v-model="searchForm"
          fieldId="customerId"
          fieldName="customerName"
        />
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchForm.categoryId"
            :placeholder="$t('product.category')"
            size="small"
            filterable
            clearable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.id"
            />
          </el-select>
        </el-form-item>
        <date-range
          v-model="searchForm"
          type="datetime"
          field="handOver"
          :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
          :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
        />
        <date-range
          v-model="searchForm"
          type="datetime"
          field="dispatch"
          :start-placeholder="$t('rules.startAt', [$t('order.dispatchAt')])"
          :end-placeholder="$t('rules.endAt', [$t('order.dispatchAt')])"
        />
        <date-range
          v-model="searchForm"
          type="datetime"
          field="finishAt"
          :start-placeholder="$t('rules.startAt', [$t('workOrder.shipAt')])"
          :end-placeholder="$t('rules.endAt', [$t('workOrder.shipAt')])"
        />
        <el-form-item>
          <el-input
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>

    <div class="wrapper table-area">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="全部" name="0"> </el-tab-pane>
        <el-tab-pane
          :label="factory.name"
          :name="factory.id + ''"
          v-for="factory of mesAuthFactories"
          :key="factory.id"
        >
        </el-tab-pane>
      </el-tabs>
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">
                  {{ $t("action.downLoadChecked") }}</el-dropdown-item
                >
                <el-dropdown-item command="search">
                  {{ $t("action.downLoadSearch") }}
                </el-dropdown-item>
              </el-dropdown-menu>

              <el-button type="info" size="mini" @click="phaseSort">
                {{ $t("menu.phases") }}排序
              </el-button>
            </el-dropdown>

            <span class="float-right font10">
              <div class="float-left color-explain bg-grey font10"></div>
              <div class="float-left mgr5 mgt5 font10">未开始</div>
              <div class="float-left color-explain bg-orange font10"></div>
              <div class="float-left mgr5 mgt5 font10">进行中</div>
              <div class="float-left color-explain bg-green font10"></div>
              <div class="float-left mgr5 mgt5 font10">已结束</div>
              <div class="float-left mgr5 mgt5 font10">日期红色代表超期</div>

              <span class="float-left mgt5">
                {{ $t("rules.pagerTotal", [pager.total]) }}，
                {{ pager.productNoQty }} 款 {{ pager.qtyTotal }} 件
              </span>
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <!-- :sort-config="{ remote: true, multiple: true }" -->
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true, multiple: true }"
        :checkbox-config="{ reserve: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="recordsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :cell-class-name="tableCellClassName"
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
          fixed="left"
          align="center"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
          fixed="left"
          align="center"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" :height="46"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          width="130"
          fixed="left"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <a @click="showRecord(row)">
              <span v-if="row.workflowState != 'canceled'">
                <span v-if="row.voidAt == null && row.jyOrderCancelAt == null">
                  <raw-html-limit-number
                    :content="row.serialNo"
                    :number="12"
                    cut="prepend"
                  />
                </span>
                <s v-if="row.voidAt != null && row.jyOrderCancelAt == null">
                  <raw-html-limit-number
                    :content="row.serialNo"
                    :number="12"
                    cut="prepend"
                  />
                </s>

                <s
                  v-if="row.voidAt == null && row.jyOrderCancelAt != null"
                  class="grey"
                >
                  <raw-html-limit-number
                    :content="row.serialNo"
                    :number="12"
                    cut="prepend"
                  />
                </s>
              </span>
              <span v-if="row.workflowState == 'canceled'" class="grey">
                <raw-html-limit-number
                  :content="row.serialNo"
                  :number="12"
                  cut="prepend"
                />
              </span>
            </a>
            <div>
              <state-label :state="row.workflowState">
                {{ $t("workOrderStates." + row.workflowState) }}
              </state-label>
              <small v-if="row.pausedAt != null" class="orange">{{
                $t("text.stop")
              }}</small>
              <a
                v-if="row.sizeTemplate"
                class="font10"
                :href="row.sizeTemplate"
                target="_blank"
              >
                {{ $t("orderMes.sizeTemplate") }}
              </a>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerName"
          :title="$t('menu.customers')"
          width="80"
          fixed="left"
        >
          <template v-slot="{ row }">
            {{ row.customerName }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          width="100"
          fixed="left"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          width="60"
          fixed="left"
        >
          <template v-slot="{ row }">
            <span :class="Number(row.quantity) > 1 ? 'red font18' : ''">
              {{ row.quantity }}{{ row.unit }}
            </span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          width="80"
          fixed="left"
          sortable
        />
        <vxe-table-column
          v-for="phase of showPhases"
          :key="phase.id"
          :title="phase.name"
          width="70"
          align="center"
          v-bind="phase"
          :field="phase.name"
          show-header-overflow
          show-overflow="title"
        >
          <template v-slot="{ row }">
            <span
              v-if="computeCurrentPhase(row, phase) != null"
              @click="cellClickShowPhase(row, phase)"
            >
              <!-- 未开始 bg-grey bg-grey-delay-->
              <span
                v-if="computeOverDate(row, phase).indexOf('bg-grey') == '-1'"
              >
                <span
                  v-if="
                    computeCurrentPhase(row, phase).manufactures.length != 0
                  "
                >
                  <raw-html-limit-number
                    :content="
                      computeCurrentPhase(row, phase).manufactures[0].workerName
                    "
                    :number="4"
                    cut="append"
                  />
                  <div class="font8" style="line-height: 8px">
                    <span
                      v-if="
                        computeCurrentPhase(row, phase) &&
                        computeCurrentPhase(row, phase).manufactures[0].startAt
                      "
                    >
                      {{
                        computeCurrentPhase(
                          row,
                          phase
                        ).manufactures[0].startAt.substring(5, 10)
                      }}
                    </span>
                  </div>
                </span>
              </span>
              <!-- 开始 -->
              <span v-else>
                <span v-if="computeCurrentPhase(row, phase).phaseMake">
                  {{ computeCurrentPhase(row, phase).phaseMake.quantity || 0 }}
                </span>
                <div
                  v-if="computeCurrentPhase(row, phase).planEndAt"
                  class="font8"
                  :class="
                    computeOverDate(row, phase).indexOf('delay') != '-1' &&
                    ['newly', 'processing'].includes(row.workflowState)
                      ? 'red'
                      : ''
                  "
                  style="line-height: 8px"
                >
                  {{
                    computeCurrentPhase(row, phase).planEndAt.substring(5, 10)
                  }}
                </div>
              </span>
            </span>
            <span v-else>--</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          :title="$t('action.qa')"
          width="60"
          align="center"
          field="qaQuantity"
        >
          <template v-slot="{ row }">
            <span
              :class="
                computeOverDateQa(row).indexOf('delay') != '-1' &&
                ['newly', 'processing'].includes(row.workflowState)
                  ? 'red'
                  : ''
              "
              @click="cellClickShowQa(row)"
            >
              {{ row.receiveQuantity || 0 }}/{{ row.qaQuantity || 0 }}
            </span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- ======== -->
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" :showPhaseHourPrice="false" />
    </drawer>
    <!-- === -->
    <!-- 工序详情展示 -->
    <vxe-modal
      v-model="showPhaseInfoDF"
      :z-index="9999"
      title="工序详情"
      width="500"
      :mask="false"
      :lock-view="false"
      resize
    >
      <vxe-table
        ref="xTablePhase"
        border
        highlight-hover-row
        highlight-current-row
        :data="manufactures"
        size="mini"
      >
        <vxe-table-column :title="$t('menu.workers')" min-width="100px">
          <template v-slot="{ row }">
            <div class="font10">
              <div class="fl">{{ row.workerName }}</div>
              <small class="fl">({{ row.workerSerialNo }})</small>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          :title="$t('text.quantity')"
          field="quantity"
          min-width="60px"
        />
        <vxe-table-column
          :title="$t('text.startAt')"
          field="startAt"
          min-width="110px"
        />
        <vxe-table-column
          :title="$t('text.endAt')"
          field="endAt"
          min-width="110px"
        />
      </vxe-table>
    </vxe-modal>
    <!-- 尾查详情展示 -->
    <vxe-modal
      v-model="showQaInfoDF"
      :z-index="9999"
      title="尾查详情"
      width="800"
      :mask="false"
      :lock-view="false"
      resize
    >
      <el-row :gutter="5">
        <el-col :span="12">
          <vxe-table
            border
            highlight-hover-row
            highlight-current-row
            :data="receives"
            size="mini"
          >
            <vxe-table-column
              field="quantity"
              :title="$t('text.quantity')"
              min-width="60px"
            />
            <vxe-table-column
              field="receiveAt"
              :title="$t('workOrder.receiveAt')"
              min-width="110px"
            />
            <vxe-table-column
              field="receiverName"
              :title="$t('workOrder.receiverName')"
              min-width="80px"
            />
          </vxe-table>
        </el-col>
        <el-col :span="12">
          <vxe-table
            border
            highlight-hover-row
            highlight-current-row
            :data="qas"
            size="mini"
          >
            <vxe-table-column
              field="quantity"
              :title="$t('text.quantity')"
              min-width="60px"
            />
            <vxe-table-column
              field="checkAt"
              :title="$t('workOrder.checkAt')"
              min-width="110px"
            />
            <vxe-table-column
              field="checkerName"
              :title="$t('workOrder.checkerName')"
              min-width="80px"
            />
          </vxe-table>
        </el-col>
      </el-row>
    </vxe-modal>

    <el-dialog
      :title="$t('text.sequence')"
      :visible.sync="phaseSortDF"
      v-if="phaseSortDF"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form ref="phaseSortObjForm" :model="phaseSortObj" label-width="60px">
        <div class="center mgb20">
          <el-radio-group
            v-model="phaseSortObj.phaseSortIndicator"
            @change="selectTotalPhaseSortIndicator"
          >
            <el-radio label="asc">升序</el-radio>
            <el-radio label="desc">降序</el-radio>
          </el-radio-group>
        </div>
        <vxe-table
          border
          row-key
          ref="phaseSortsTable"
          class="sortable-row-demo"
          :scroll-y="{ enabled: false }"
          :data="phaseSorts"
          size="mini"
        >
          <vxe-table-column width="60">
            <template v-slot="{ row, rowIndex }">
              <i
                v-if="rowIndex != 0"
                class="el-icon-top mgr10"
                @click="swapSequence(row, rowIndex, 'up')"
              ></i>
              <i
                v-if="
                  rowIndex + 1 !=
                  (pager.pageSize > pager.total ? pager.total : pager.pageSize)
                "
                class="el-icon-bottom"
                @click="swapSequence(row, rowIndex, 'down')"
              ></i>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="name"
            :title="$t('menu.phases')"
          ></vxe-table-column>
          <vxe-table-column field="phaseSortIndicator" :title="'排序'">
            <template v-slot="{ row, rowIndex }">
              <!-- <el-radio-group v-model="row.phaseSortIndicator">
                <el-radio label="asc">升序</el-radio>
                <el-radio label="desc">降序</el-radio>
              </el-radio-group>
              <i
                class="el-icon-circle-close mgl20 gray"
                @click="clearSort(rowIndex)"
              ></i> -->
              <el-select v-model="row.phaseSortIndicator" size="mini" clearable>
                <el-option :label="'升序'" value="asc"> </el-option>
                <el-option :label="'降序'" value="desc"> </el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button
                type="text"
                size="mini"
                @click="removePhaseSorts(row, rowIndex)"
              >
                {{ $t("text.remove") }}
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="phaseSortSubmitDoing"
          size="small"
          @click="phaseSortSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="phaseSortDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import { flagsWithClear, flagsWithNone } from "@/utils/enums.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";
import CustomerSearch from "@/components/CustomerSearch";

import DateRange from "@/components/DateRange";
import Flag from "@/components/Flag";
import TinymceEditor from "@/components/TinymceEditor";
import Qrcode from "@chenfengyuan/vue-qrcode";
import JsBarcode from "jsbarcode";
import Brand from "@/api/brand.js";
import Factory from "@/api/factory.js";
import UserFactory from "@/api/userFactory.js";

import WorkOrder from "@/api/workOrder.js";
import Phase from "@/api/phase.js";
import UserAuth from "@/api/userAuth.js";
import Show from "@/views/mes/workOrders/show.vue";
import Qa from "@/api/qa.js";
import Receive from "@/api/receive.js";
import Category from "@/api/category.js";
import PagerConfig from "@/config/pager.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Thumbnail,
    RawHtmlLimitNumber,
    RawHtml,
    DateRange,
    TinymceEditor,
    Flag,
    Qrcode,
    JsBarcode,
    Show,
    CustomerSearch,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "workOrders_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        handOverAt: "workOrders_handOverAt",
      },
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: WorkOrder.nearRange,
          },
        ],
        [
          {
            label: this.$t("order.passRange"),
            items: WorkOrder.passRange,
          },
          {
            label: this.$t("text.flag"),
            items: flagsWithNone.map((flag) => {
              return { flag: flag, key: flag, condition: { flag: flag } };
            }),
          },
        ],
        [
          {
            label: this.$t("text.workflowState"),
            items: WorkOrder.states_all.map((s) => {
              return {
                label: this.$t("workOrderStates." + s),
                key: s,
                condition: { workflowState: s },
              };
            }),
          },
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: true },
              },
              {
                label: this.$t("action.pause"),
                key: "'yes'",
                condition: { pause: "yes" },
              },
              {
                label: this.$t("action.retrieve"),
                key: "yes",
                condition: { voidAt: "yes" },
              },
              {
                label: this.$t("text.unPrint"),
                key: "unPrint",
                condition: { print: "no" },
              },
              {
                label: this.$t("workOrder.inProduction"),
                key: "inProduction",
                condition: {
                  workflowStates: ["newly", "processing"],
                  pause: "no",
                },
              },
              {
                label: this.$t("workOrder.unFinished"),
                key: "unFinished",
                condition: {
                  workflowStates: ["newly", "processing", "processed"],
                },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("workOrder.phaseProcessingInfo"),
            items: WorkOrder.phaseProcessingInfos.map((phaseProcessingInfo) => {
              return {
                label: this.$t("phaseProcessingInfos." + phaseProcessingInfo),
                key: phaseProcessingInfo,
                condition: {
                  type: phaseProcessingInfo,
                },
              };
            }),
          },
        ],
      ],
      initFilter: "inProduction",
      searchForm: {
        serialNo: null,
        orderInnerSerialNo: null,
        customerId: null,
        customerName: null,
        handOverStartAt: null,
        handOverEndAt: null,
        dispatchStartAt: null,
        dispatchEndAt: null,
        handle: null,
        productNo: null,
        productBrand: null,
        categoryId: null,
        finishAtStartAt: null,
        finishAtEndAt: null,
      },
      Util: Util,
      flagsWithNone: flagsWithNone,
      flagsWithClear: flagsWithClear,
      brands: [],
      factories: [],
      userFactories: [],
      mesAuthFactories: [],
      phases: [],
      showPhases: [],
      currentUserManagePhaseIds: [],
      printTemplates: [],
      categories: [],
      showDF: false,
      currentRowIdx: null,
      currentRowId: null,
      currentRowUuid: null,
      //
      //
      showQaInfoDF: false,
      showPhaseInfoDF: false,
      manufactures: [],
      qas: [],
      receives: [],
      activeName: "0",
      //
      showHelpTip1: false,
      phaseSortDF: false,
      phaseSortObj: {
        phaseSortIndicator: null,
      },
      phaseSorts: [],
      phaseSortSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    axios
      .all([
        Brand.findByTenantId(),
        Factory.findByTenantId(),
        UserFactory.findByUserId(self.Permit.currentUser().id),
        Phase.findByTenantId(),
        UserAuth.findByIdMes(self.Permit.currentUser().id),
        Category.findByTenantId(),
      ])
      .then(
        axios.spread(function (
          brands,
          factories,
          userFactories,
          phases,
          userAuthsMes,
          categories
        ) {
          if (brands.status === 200) {
            self.brands = brands.data;
          } else {
            self.sysError();
          }
          if (factories.status === 200) {
            self.factories = factories.data;
          } else {
            self.sysError();
          }
          if (userFactories.status == 200) {
            self.userFactories = userFactories.data;

            if (self.Permit.currentUser().admin === true) {
              self.mesAuthFactories = self.factories;
            } else {
              const userFactoryIds = self.userFactories.map((u) => u.factoryId);
              self.mesAuthFactories = self.factories.filter((f) =>
                userFactoryIds.includes(f.id)
              );
            }
            self.narrowsFactoriesBrands();
          } else {
            self.sysError();
          }
          if (phases.status === 200) {
            self.phases = phases.data;
            self.showPhases = phases.data;
          } else {
            self.sysError();
          }
          if (userAuthsMes.data.code === 200) {
            self.currentUserManagePhaseIds = JSON.parse(
              userAuthsMes.data.entity.phasesJson || "[]"
            );
          } else {
            // 其他是没有授权的
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          self.narrowsPhases();
        })
      );
  },
  methods: {
    phaseSort() {
      const self = this;
      if (self.showPhases.length == 0) {
        self.$message({
          message: "至少有一个工序",
          type: "warning",
        });
        return;
      }
      this.phaseSortObj.phaseSortIndicator = null;
      self.phaseSorts = self.showPhases.map((phsae) => {
        return {
          id: phsae.id,
          name: phsae.name,
          phaseSortIndicator: null,
        };
      });
      self.phaseSorts = self.phaseSorts.reverse();
      self.phaseSortDF = true;
    },
    selectTotalPhaseSortIndicator() {
      if (this.phaseSorts.length == 0) {
        return;
      }
      for (const phase of this.phaseSorts) {
        phase.phaseSortIndicator = this.phaseSortObj.phaseSortIndicator;
      }
    },
    removePhaseSorts(row, rowIndex) {
      this.phaseSorts.splice(rowIndex, 1);
    },
    swapSequence(row, rowIndex, type) {
      let oldIndex = rowIndex;
      let newIndex = null;
      if (type == "up") {
        newIndex = rowIndex - 1;
      } else {
        newIndex = rowIndex + 1;
      }
      const currRow = this.phaseSorts.splice(oldIndex, 1)[0];
      this.phaseSorts.splice(newIndex, 0, currRow);
    },
    phaseSortSubmit() {
      const self = this;
      const phaseSortsFilter = self.phaseSorts.filter(
        (p) => p.phaseSortIndicator != null
      );
      if (phaseSortsFilter.length == 0) {
        self.$message({
          message: "至少设置一个工序排序",
          type: "warning",
        });
        return;
      }
      this.searchForm.phaseSortBy = phaseSortsFilter
        .map((item) => item.id)
        .join("&");
      this.searchForm.phaseSortIndicator = phaseSortsFilter
        .map((item) => item.phaseSortIndicator)
        .join("&");
      // console.log(
      //   this.searchForm.phaseSortBy,
      //   "=====",
      //   this.searchForm.phaseSortIndicator
      // );
      self.phaseSortDF = false;
      this.loadData();
    },

    // sortRecords({ sortList }) {
    //   const fixColumns = ["handOverAt"];
    //   //
    //   if (sortList.length != 0) {
    //     for (let s of sortList) {
    //       if (fixColumns.includes(s.property)) {
    //         s.sortBy = s.property;
    //         if (!s.order) {
    //           this.actionSorter.sortBy = this.sorter.sortBy;
    //           this.actionSorter.sortIndicator = this.sorter.sortIndicator;
    //         } else {
    //           this.actionSorter.sortBy = this.sorterMap[s.property];
    //           this.actionSorter.sortIndicator = s.order;
    //         }
    //       } else {
    //         s.sortBy = this.phases.find((p) => p.name == s.property).id;
    //       }
    //     }
    //   }
    //   this.loadData();
    // },
    handleClick(tab, event) {
      this.pager.currentPage = 1;
      this.pager.pageSize = PagerConfig.normal.defaultPageSize;
      this.searchForm.phaseSortBy = null;
      this.searchForm.phaseSortIndicator = null;
      this.searchForm.factoryId = null;
      this.$refs.recordsTable.clearFilter();
      if (Number(this.activeName) == 0) {
        this.showPhases = this.phases;
      } else {
        this.searchForm.factoryId = Number(this.activeName);
        let factoryObj = this.factories.find(
          (f) => f.id == Number(this.activeName)
        );
        this.showPhases = factoryObj.factoryPhases.map((f) => {
          return {
            id: f.phaseId,
            name: f.phaseName,
            tenantId: null,
            deletedAt: null,
            sequence: f.sequence,
            phaseGroupId: null,
            phaseGroupName: null,
            factoryPhases: null,
          };
        });
      }
      this.loadData();
    },
    cellClickShowPhase(row, phase) {
      this.manufactures = this.computeCurrentPhase(row, phase).manufactures;
      this.showPhaseInfoDF = true;
    },
    cellClickShowQa(row) {
      this.qas = [];
      this.receives = [];
      this.getQrRecords(row.id);
      this.getReceiveRecords(row.id);
      this.showQaInfoDF = true;
    },
    getQrRecords(workOrderId) {
      const self = this;
      Qa.findByWorkerOrderId(workOrderId).then(function (res) {
        if (res.status === 200) {
          self.qas = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getReceiveRecords(workOrderId) {
      const self = this;
      Receive.findByWorkerOrderId(workOrderId).then(function (res) {
        if (res.status === 200) {
          self.receives = res.data;
        } else {
          self.sysError();
        }
      });
    },

    //
    computeCurrentPhase(row, currentPhase) {
      // return row.phasePlansMap["id_" + currentPhase.id]
      if (row.phasePlans.length !== 0) {
        const currentPhasePlans = row.phasePlans.filter(
          (p) => p.phaseId === currentPhase.id
        );
        if (currentPhasePlans.length !== 0) {
          return currentPhasePlans[0];
        }
        return null;
      }
      return null;
    },
    computeOverDate(row, currentPhase) {
      const phasePlan = this.computeCurrentPhase(row, currentPhase);
      if (phasePlan && phasePlan.phaseMake != null) {
        if (phasePlan.phaseMake.startAt == null) {
          if (Util.dateDiff(new Date(), phasePlan.planEndAt) > 0) {
            // 未开始 且延期了
            return "bg-grey-delay";
          } else {
            // 未开始
            return "bg-grey";
          }
        } else {
          if (phasePlan.phaseMake.finishAt == null) {
            if (Util.dateDiff(new Date(), phasePlan.planEndAt) > 0) {
              // 未完成 且延期了
              return "bg-orange-delay";
            } else {
              // 未完成
              return "bg-orange";
            }
          } else {
            // 完成的 但是延期了
            if (
              phasePlan.planEndAt != null &&
              Util.dateDiff(phasePlan.phaseMake.finishAt, phasePlan.planEndAt) >
                0
            ) {
              return "bg-green-delay";
            } else {
              // 完成的
              return "bg-green";
            }
          }
        }
      }
      return "";
    },
    computeOverDateQa(row) {
      if (
        (row.receiveQuantity == null || row.receiveQuantity === 0) &&
        (row.qaQuantity == null || row.qaQuantity === 0)
      ) {
        if (Util.dateDiff(new Date(), row.handOverAt) > 0) {
          return "bg-grey-delay";
        }
        return "bg-grey";
      }
      if (row.qaQuantity === row.quantity) {
        if (Util.dateDiff(new Date(), row.handOverAt) > 0) {
          return "bg-green-delay";
        }
        return "bg-green";
      }
      if (Util.dateDiff(new Date(), row.handOverAt) > 0) {
        return "bg-orange-delay";
      }
      return "bg-orange";
    },

    // 下载
    download(type) {
      const self = this;
      if (type === "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: this.selectRecords.map((c) => c.id),
        };
        this.downloadData(data);
      } else {
        if ((JSON.stringify(self.conditions) === "{}") === true) {
          this.$message.error(this.$t("prompt.downloadNoSearchCondition"));
          return;
        }
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      WorkOrder.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex < 7 &&
        ["newly", "processing"].includes(row.workflowState) &&
        row.handOverAt !== null
      ) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return "warning-row";
        }
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return "special-row";
        }
      }
      if (this.showPhases.filter((p) => p.name === column.title).length !== 0) {
        const currentPhase = this.showPhases.filter(
          (p) => p.name === column.title
        )[0];
        if (this.computeCurrentPhase(row, currentPhase) != null) {
          return this.computeOverDate(row, currentPhase);
        }
        return "";
      }
      if (column.title === "尾查") {
        return this.computeOverDateQa(row);
      }
      return "";
    },

    //==
    narrowsPhases() {
      if (this.phases.length != 0) {
        let phases = [];
        if (this.Permit.currentUser().admin) {
          phases = this.phases;
        } else {
          phases = this.phases.filter((p) =>
            this.currentUserManagePhaseIds.includes(p.id)
          );
        }
        this.narrows.push([
          {
            label: this.$t("menu.phases"),
            items: phases.map((phase) => {
              return {
                label: phase.name,
                key: JSON.stringify(phase.id),
                condition: { phaseId: phase.id },
              };
            }),
          },
        ]);
      }
    },
    narrowsFactoriesBrands() {
      this.narrows.push([
        // {
        //   label: this.$t("menu.factories"),
        //   items: this.mesAuthFactories.map((factory) => {
        //     return {
        //       label: factory.name,
        //       key: factory.id,
        //       condition: { factoryId: factory.id },
        //     };
        //   }),
        // },
        {
          label: this.$t("product.brand"),
          items: this.brands.map((brand) => {
            return {
              label: brand.name,
              key: brand.name,
              condition: { brand: brand.name },
            };
          }),
        },
      ]);
    },
    showRecord(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    //======
    dataProvider(params) {
      return WorkOrder.trackingSearch(params);
    },
  },
};
</script>
<style>
.color-explain {
  height: 10px;
  width: 40px;
  border: 1px solid #eee;
  margin-top: 7px;
  margin-right: 5px;
}
.bg-green {
  background: #67c23a;
  color: #fff;
}
.bg-orange {
  background: #eb9e05;
  color: #fff;
}
.bg-grey {
  background: #fafafa;
}

.bg-green-delay {
  background: #67c23a;
  color: #fff;
}
.bg-orange-delay {
  background: #eb9e05;
  color: #fff;
}
.bg-grey-delay {
  background: #fafafa;
}

.warning-row {
  background: rgba(248, 218, 174, 1);
}

.special-row {
  background: rgba(255, 190, 194, 1);
}
.vxe-table.size--mini .vxe-body--column.col--ellipsis > .vxe-cell,
.vxe-table.size--mini .vxe-footer--column.col--ellipsis > .vxe-cell,
.vxe-table.size--mini .vxe-header--column.col--ellipsis > .vxe-cell {
  min-height: 48px;
}

/* .vxe-table.size--mini .vxe-body--column:not(.col--ellipsis),
.vxe-table.size--mini .vxe-footer--column:not(.col--ellipsis),
.vxe-table.size--mini .vxe-header--column:not(.col--ellipsis) {
  padding: 0px 0;
}

.vxe-table .vxe-cell {
  white-space: pre-line;
  word-break: break-all;
  padding-left: 2px;
  padding-right: 2px;
  font-size: 12px;
} */
</style>
